import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

var Winelist = /*#__PURE__*/function () {
  function Winelist(config, axios) {
    _classCallCheck(this, Winelist);

    _defineProperty(this, "axios", void 0);

    _defineProperty(this, "config", void 0);

    this.axios = axios;
    this.config = config;
  }

  _createClass(Winelist, [{
    key: "getWinelist",
    value: function () {
      var _getWinelist = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(restaurantNumber) {
        var commonQueryParams, locale, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                _context.next = 4;
                return this.axios.get(this.config.postfix.GET_WINE_LIST, {
                  params: {
                    locationID: restaurantNumber,
                    locale: locale,
                    conceptCode: this.config.getConceptCode()
                  },
                  headers: {
                    customTimeout: 20000
                  }
                });

              case 4:
                response = _context.sent;

                if (!response) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return", response.data);

              case 7:
                return _context.abrupt("return", null);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getWinelist(_x) {
        return _getWinelist.apply(this, arguments);
      }

      return getWinelist;
    }()
  }]);

  return Winelist;
}();

export { Winelist as default };